define.alias("shared/components/shared/addon-details-card/current-plan", "media/components/shared/addon-details-card/current-plan");